export default __webpack_public_path__ + "static/media/steel-blue.47dc177f.jpg";